import axios from 'axios';
import Cookies from 'js-cookie';

const baseUrl = 'https://api-plombokan.rezafatur.my.id/';

const api = axios.create({
  baseURL: baseUrl,
  headers: {},
});

api.interceptors.request.use((config) => {
  const token = Cookies.get('access');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  };
  
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
